import create from 'zustand';
import { Subscription, subscription } from './api';

export const keyCodes = <const>['Escape'];

type KeyMap<T = any> = {
  [K in typeof keyCodes[number]]: T;
};

export type KeyboardApi = {
  keydown: Subscription<KeyMap>;
  keyup: Subscription<KeyMap>;
  unsubscribe: () => void;
};

export function keyboardApi(init?: (api: KeyboardApi) => void): KeyboardApi {
  const keydownData = create<KeyMap>(() => ({} as any));
  const keydown = subscription<KeyMap<KeyboardEvent>>(
    keyCodes as any,
    keydownData
  );

  function onKeyDown(e: KeyboardEvent) {
    const state = {};
    state[e.code] = e;
    keydownData.setState(state);
  }

  const keyupData = create<KeyMap>(() => ({} as any));
  const keyup = subscription<KeyMap<KeyboardEvent>>(keyCodes as any, keyupData);

  function onKeyUp(e: KeyboardEvent) {
    const state = {};
    state[e.code] = e;
    keyupData.setState(state);
  }

  function unsubscribe() {
    window.removeEventListener('keydown', onKeyDown);
    window.removeEventListener('keyup', onKeyUp);
    keydown.unsubscribe();
    keyup.unsubscribe();
  }

  const api = { keydown, keyup, unsubscribe };

  if (init) {
    init(api);
  }
  //TODO: enable / disable
  window.addEventListener('keydown', onKeyDown);
  window.addEventListener('keyup', onKeyUp);

  return api;
}

export function keyboardEvents(
  fn: (a: KeyboardApi) => void,
  enable: any = true
): (enable?: any) => void {
  let api: KeyboardApi;
  const init = (enable?: any) => {
    if (api) {
      api.unsubscribe();
    }
    if (enable) {
      api = keyboardApi(fn);
    }
  };
  init(enable);
  return init;
}
